import React from 'react';
import {
  StackScreen,
  Flex,
  useScreenSize,
  SafeAreaTopSpacing,
} from '@banhala/ui-kit';
import { WebView } from 'shared/src/component/WebWebView';
import { isNotNil } from 'shared/src/utils';
import { useWebBaseURL } from 'shared/src/hooks';

export const TodayShippingScreen: React.FC = () => {
  const { width: screenWidth } = useScreenSize();
  const webBaseUrl = useWebBaseURL();

  return (
    <StackScreen title={'오늘출발'} hideBackButton={true} hideHeader={true}>
      <SafeAreaTopSpacing />
      <Flex flex={1} alignItems={'center'}>
        <Flex width={screenWidth} flex={1}>
          {isNotNil(webBaseUrl) && (
            <WebView
              source={{
                uri: `${webBaseUrl}/today-delivery?title_bar=false`,
              }}
            />
          )}
        </Flex>
      </Flex>
    </StackScreen>
  );
};
